import * as React from 'react';
import { Notification, Loader } from '../';
import Statistic from './IStatistic';

interface Props {
  isFetching: boolean;
  statistics: Array<Statistic>;
}

const StatisticsTable = ({ isFetching, statistics }: Props) => (
  <div>
    <table>
      <thead>
        <tr>
          <th>Vehicle Type</th>
          <th>No. of Customers</th>
          <th>Total Days Hired</th>
        </tr>
      </thead>
      {!isFetching && (
        <tbody>
          {statistics.map(
            (statistic) =>
              statistic.vehicleType && (
                <tr key={statistic.vehicleType.id}>
                  <td>
                    <div className="media">
                      <figure className="media-left">
                        <span className="avatar image is-32x32">
                          <img
                            src={statistic.vehicleType.image}
                            alt={statistic.vehicleType.name}
                          />
                        </span>
                      </figure>
                      <div className="media-content">
                        {statistic.vehicleType.name}
                      </div>
                    </div>
                  </td>
                  <td>{statistic.bookings}</td>
                  <td>{statistic.days}</td>
                </tr>
              ),
          )}
          {!!statistics.length && (
            <tr>
              <td>
                <strong>Total</strong>
              </td>
              <td>
                {!!statistics.length &&
                  statistics
                    .map((statistic) => statistic.bookings)
                    .reduce((a, b) => a + b)}
              </td>
              <td>
                {!!statistics.length &&
                  statistics
                    .map((statistic) => statistic.days)
                    .reduce((a, b) => a + b)}
              </td>
            </tr>
          )}
        </tbody>
      )}
    </table>
    {isFetching && <Loader fullwidth />}
    {!isFetching &&
      !statistics.length && (
        <Notification type="default">
          There were no bookings during this period
        </Notification>
      )}
  </div>
);

export default StatisticsTable;
